import React from 'react';

import { Feature, OptForm } from '../components';
import { HeaderContainer } from '../containers/header';
import { FaqsContainer } from '../containers/faqs';
import { FooterContainer } from '../containers/footer';

export default function Home() {
  return (
    <>
      <HeaderContainer>
        <Feature>
          <Feature.Title>
            Hello I'm Mansour Mahamat-Salle ! <br /> A Frontend Developer
          </Feature.Title>
          <Feature.SubTitle>
            I love working with React, SCSS and playing with APIs
          </Feature.SubTitle>
          <OptForm>
            <OptForm.Input
              readonly
              placeholder="Mansour.mahamat.salle@gmail.com"
            />
            <OptForm.Button href="mailto:Mansour.mahamat.salle@gmail.com">
              Contact me
            </OptForm.Button>
            <OptForm.Break />
            <OptForm.Text>
              Ready to talk with me ? Click the red button and send me an email.
            </OptForm.Text>
          </OptForm>
        </Feature>
      </HeaderContainer>

      {/* <JumbotronContainer /> */}
      <FaqsContainer />
      <FooterContainer />
    </>
  );
}
